var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bar4"}},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('h2',[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('img',{attrs:{"src":"static/kanbanbg.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c7547f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/tangci/paigongxiangmu.vue
// module id = null
// module chunks = 